import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { resetPassword } from '../services/firebase';
import styles from './ForgotPasswordPage.module.css';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) { setError('Lütfen e‑posta adresinizi giriniz.'); return; }
    try {
      setLoading(true); setError(null);
      await resetPassword(email);
      setSuccess(true);
    } catch (err: any) {
      setError(err.message || 'Şifre sıfırlama e-postası gönderilirken hata oluştu.');
    } finally { setLoading(false); }
  };

  return (
    <div className={styles.forgotPage}> {/* outer layout */}
      <div className={styles.forgotShell}>
        <div className={styles.headArea}>
          <img src="/logo.png" alt="vagonla" className={styles.brandLogo} />
          <h1 className={styles.pageTitle}>Şifremi Unuttum</h1>
          {!success && <p className={styles.pageSubtitle}>Kayıtlı e‑posta adresini gir, sana sıfırlama bağlantısı gönderelim.</p>}
        </div>
        <div className={styles.formCardGlass}>
          {error && <div className={styles.errorBox}>{error}</div>}
          {!success && (
            <form onSubmit={handleSubmit} className={styles.formLayout}>
              <div className={styles.fieldGroup}>
                <label htmlFor="email" className={styles.fieldLabel}>E‑posta</label>
                <input
                  type="email"
                  id="email"
                  className={styles.pillInput}
                  value={email}
                  onChange={e=>setEmail(e.target.value)}
                  disabled={loading}
                  placeholder="ornek@eposta.com"
                  required
                />
              </div>
              <button type="submit" className={styles.primaryAction} disabled={loading}>
                {loading ? 'Gönderiliyor…' : 'Bağlantı Gönder'}
              </button>
              <div className={styles.altAction}>Giriş sayfasına dön <Link to="/login">Giriş Yap</Link></div>
            </form>
          )}
          {success && (
            <div className={styles.successBox}>
              <h2 className={styles.successTitle}>E‑posta Gönderildi</h2>
              <p className={styles.successText}>Şifre sıfırlama talimatları <strong>{email}</strong> adresine gönderildi. Gelen kutunu ve spam klasörünü kontrol et.</p>
              <div className={styles.successActions}>
                <Link to="/login" className={styles.primaryAction}>Girişe Dön</Link>
                <button type="button" className={styles.btnGhost} onClick={()=>{ setSuccess(false); setEmail(''); }}>Yeni e‑posta</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
